import {
    html5,
    css3,
    js,
    sass,
    react,
    redux,
    tailwind,
    bootstrap,
    nodejs,
    socketio,
    firebase,
    typescript,
    express,
  } from './SkillAssets';

 const skillItems = [
    { name: 'HTML 5', img: html5 },
    { name: 'CSS 3', img: css3 },
    { name: 'JS', img: js },
    { name: 'Sass', img: sass },
    { name: 'Tailwind', img: tailwind },
    { name: 'Bootstrap', img: bootstrap },
    { name: 'React', img: react },
    { name: 'Redux', img: redux },
    { name: 'Typescript', img: typescript },
    { name: 'Node JS', img: nodejs },
    { name: 'Express JS', img: express },
    { name: 'Firebase', img: firebase },
    { name: 'Socket IO', img: socketio },
  ];

  export default skillItems;